import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import FarewellPage from "./pages/FarewellPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<FarewellPage locale="en" />} />
        <Route path="/ru" element={<FarewellPage locale="ru" />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
